import { Badge } from "@src/common/components";

interface ReturnTripOnlyBadgeProps {
  show: boolean;
}

function ReturnTripOnlyBadge({ show }: ReturnTripOnlyBadgeProps) {
  if (!show) {
    return null;
  }

  return (
    <div className="mt-1 inline-block">
      <Badge color="warning" size="xs" className="inline-block w-fit">
        RETURN TRIP ONLY
      </Badge>
    </div>
  );
}

export default ReturnTripOnlyBadge;
